import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, Typography, Box, Avatar, Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Snackbar, Alert } from "@mui/material";
import {
  People as PeopleIcon,
  Label as LabelIcon,
  Campaign as CampaignIcon,
  AutoAwesome as AutomationIcon,
  AccountTree as FlowIcon,
} from "@mui/icons-material";
import MyAccountService from "../services/MyAccountService";
import { getShortStoreName } from "../utils/extentions";
import FormField from "./FormField";
import { Heading, Text } from "evergreen-ui";
import { IntegrationDialog } from "./Dialog";
import ServicesService from "../services/ServicesService";
import WhatsApp from "../models/WhatsappModel";
import { errorMessage } from "../shared/utils/validators";

const TopNavigation = ({
  onMenuClick,
  title,
  activeTab = "contacts",
  onTabChange,
}) => {
  const [appId, setAppId] = useState(null);
  const [configId, setConfigId] = useState(null);
  const [pinValue, setPinValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isFbReady, setIsFbReady] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [whatsapp, setWhatsapp] = useState({
    phoneNumberId: '',
    wabaId: '',
    accessToken: '',
  });
  const [snackBar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  })
  const [whatsappId, setWhatsappId] = useState(null);
  console.log('whhhhh', whatsapp);
  
  const tabs = [
    {
      id: "contacts",
      label: "Contacts",
      icon: <PeopleIcon fontSize="small" />,
    },
    {
      id: "tags",
      label: "Tags",
      icon: <LabelIcon fontSize="small" />,
    },
    {
      id: "broadcast",
      label: "Broadcast",
      icon: <CampaignIcon fontSize="small" />,
    },
    {
      id: "automation",
      label: "Automation",
      icon: <AutomationIcon fontSize="small" />,
    },
    {
      id: "flow",
      label: "Flow",
      icon: <FlowIcon fontSize="small" />,
    },
  ];
  const [accName, setAccName] = useState('WG');
  function renderForm() {
    return (
      <div style={{ paddingTop: 10, paddingBottom: 10 }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 10,
        }}
        >
          <Heading size={500}>Two factor autenticate Pin</Heading>
        </div>
        <Text style={{ paddingTop: 15 }}>
          Enter 6 digit while signup and remember it for later login.
        </Text>
        <FormField
          type="text"
          label="Six Digit Pin"
          isRequired
          name="pin"
          value={pinValue}
          onChange={(e) => {
            setPinValue(e.target.value);
          }}
          error={pinValue?.length > 6 ? 'Enter 6 digit only' : null}
        />
        <div className="flex" style={{ justifyContent: 'end', marginTop: '30px', columnGap: 20 }}>
          <Button
            type="submit"
            label="Continue with Facebook"
            disabled={pinValue?.length > 6 || !isFbReady}
            onClick={() => {
              launchWhatsAppSignup();
            }}
          >
            Facebook login
          </Button>
        </div>
      </div>
    );
  }
  function snackbar() {
    return (
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    )
  }
  function renderLoginDialog() {
    return (
      <IntegrationDialog
        isOpen={isOpen}
        title="Facebook Login"
        content={renderForm}
        onCancel={() => {
          setIsOpen(false);
        }}
      />
    );
  }
  function fetchData() {
    ServicesService.getWhatsapp('whatsapp').then((response) => {
      console.log('ressss', response);
      
    setWhatsapp({
      phoneNumberId: response?.getPhoneNumberId(),
      wabaId: response?.getWabaId(),
      accessToken: response?.getAccessToken(),
    });
    setWhatsappId(response?.getId());
  });
  }
  function handleWhatsappChange(value, field) {
    setWhatsapp((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  async function handleSaveWhatsapp() {
    try {
      const model = new WhatsApp();
      model.setPhoneNumberId(whatsapp.phoneNumberId);
      model.setWabaId(whatsapp.wabaId);
      model.setAccessToken(whatsapp.accessToken);
      const id = await ServicesService.createWhatsapp(model);
      setWhatsapp(model);
      setWhatsappId(id);
      setSnackbar({
        open: true,
        message: 'Chatbot created successfully!',
        severity: "success",
      });
      setIsProfileOpen(false);
    } catch (error) {
      const message = errorMessage(error);
      if (message) {
        setSnackbar({
          open: true,
          message: `${message}`,
          severity: "error",
        });
      } else {
        setSnackbar({
          open: true,
          message: 'Something went wrong',
          severity: "error",
        });
      }
    }
  }
  useEffect(() => {
    MyAccountService.fetch().then((model) => {
      console.log('model', model);
      
      setAccName(model)
    });
    ServicesService.getAppId().then((res) => {
      setAppId(res.appID);
      setConfigId(res.configID);
    });
    fetchData();
  }, []);
  function handleOpenFacebook() {
    setIsOpen(true);
  }
  useEffect(() => {
    if (!appId) return;
    // Load Facebook SDK script if not already loaded
    if (!document.getElementById('facebook-jssdk')) {
      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      document.body.appendChild(script);
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v23.0',
      });
      setIsFbReady(true);
      console.log('ini called');
      
    };

  async function handleMessage(event) {
    if (!event.origin.endsWith('facebook.com')) return;
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        console.log('Signup message event:', data);
        const body = JSON.stringify(data);
        const model = new WhatsApp();
        model.setPhoneNumberId(body.data.phone_number_id);
        model.setWabaId(body.data.waba_id);
        model.setBusinessId(body.data.business_id);
        await ServicesService.createWhatsapp(model);
      }
    } catch (err) {
      console.log('Raw message event:', event.data);
    }
  }
  window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [appId]);
  const launchWhatsAppSignup = () => {
    if (!isFbReady || !window.FB || !window.FB.login) {
    console.error('Facebook SDK is not ready yet.');
    return;
  }
  async function handleAccessTokenExchange(code) {
    try {
      console.log('Token code:', code);
      const token = await ServicesService.getAccessTokenByExchangeToken(code, pinValue);
      console.log('access_token', token);
    } catch (error) {
      console.error('Error during token exchange:', error);
    }
  }
  function fbLoginCallback(response) {
    if (response.authResponse) {
      const { code } = response.authResponse;
      console.log('Token code:', code);
      handleAccessTokenExchange(code);
    } else {
      console.log('FB login failed:', response);
    }
  }
    window.FB.login(fbLoginCallback, {
      config_id: configId,
      response_type: 'code',
      override_default_response_type: true,
      extras: {
        setup: {},
        featureType: '', // e.g., 'only_waba_sharing' or 'whatsapp_business_app_onboarding'
        sessionInfoVersion: '3',
      },
    });
  };
  const iswhatsapp = whatsapp.phoneNumberId != null || whatsapp.phoneNumberId !== '';
  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "#fff",
        color: "#333",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* Left Section */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          {/* Logo */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 32,
                height: 32,
                backgroundColor: "#1976d2",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              S
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: "#1976d2" }}>
              WappGrow
            </Typography>
          </Box>

          {/* Navigation Tabs */}
          <Box sx={{ display: "flex", gap: 0 }}>
            {tabs.map((tab) => (
              <Box
                key={tab.id}
                onClick={() => onTabChange && onTabChange(tab.id)}
                sx={{
                  px: 2.5,
                  py: 1.5,
                  cursor: "pointer",
                  backgroundColor:
                    activeTab === tab.id ? "#e3f2fd" : "transparent",
                  color: activeTab === tab.id ? "#1976d2" : "#666",
                  fontWeight: activeTab === tab.id ? 600 : 500,
                  fontSize: "14px",
                  textTransform: "capitalize",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  borderRadius: "4px 4px 0 0",
                  "&:hover": {
                    backgroundColor:
                      activeTab === tab.id ? "#e3f2fd" : "#f8f9fa",
                  },
                }}
              >
                {tab.icon}
                {tab.label}
              </Box>
            ))}
          </Box>
        </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end'}}>
            <Button
            variant="contained"
            onClick={() => handleOpenFacebook()}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
              borderRadius: 2,
              px: 3,
            }}
          >
            Facebook
          </Button>
            </Box>
        {/* Right Section */}
        <Box sx={{ display: "flex", alignItems: "center" }} onClick={() => {
          fetchData()
          setIsProfileOpen(true)
          }}>
          {/* User Profile */}
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: "#1976d2",
              fontSize: "0.875rem",
            }}
          >
            {getShortStoreName(accName?.getFirstName?.())}
          </Avatar>
        </Box>
      </Toolbar>
      <Dialog
        open={isProfileOpen}
        onClose={() => {
          setIsProfileOpen(false);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          },
        }}
      >
      <DialogTitle
          sx={{
            pb: 1,
            fontSize: "20px",
            fontWeight: 600,
            color: "#1a1a1a",
          }}
        >
          Whatsapp details
        </DialogTitle>
        <DialogContent sx={{ pt: 5 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, p: 1 }}>
            <TextField
              label="Phonenumber Id"
              placeholder={!iswhatsapp ? 'Enter Phonenumber id' : null}
              fullWidth
              value={whatsapp.phoneNumberId}
              onChange={(e) => handleWhatsappChange(e.target.value, 'phoneNumberId')}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
            <TextField
              label="Waba Id"
              placeholder={!iswhatsapp ? 'Enter Waba id' : null}
              fullWidth
              value={whatsapp.wabaId}
              onChange={(e) => handleWhatsappChange(e.target.value, 'wabaId')}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
            <TextField
              label="Access Token"
              placeholder={!iswhatsapp ? 'Enter AccessToken' : null}
              fullWidth
              value={whatsapp.accessToken}
              onChange={(e) => handleWhatsappChange(e.target.value, 'accessToken')}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button
            onClick={() => setIsProfileOpen(false)}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveWhatsapp}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
              borderRadius: 2,
              px: 3,
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {snackbar()}
      {renderLoginDialog()}
    </AppBar>
  );
};

export default TopNavigation;
